import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      error: error,
      info: info
    });
  }
  static propTypes = {
    children: PropTypes.any
  };
  render() {
    const errorView = (
      <React.Fragment>
        <section className="hero is-danger">
          <div className="hero-body">
            <div className="container">
              <h1 className="title">
                <FormattedMessage id={"app.title"} />
              </h1>
              <h2 className="subtitle">
                <FormattedMessage id={"errorBoundary.subtitle"} />
              </h2>
              <h2 className="subtitle">
                {this.state.error ? this.state.error.message : ""}
                {this.state.info ? this.state.info.componentStack : ""}
              </h2>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
    const view = this.state.hasError ? errorView : this.props.children;
    return view;
  }
}
export default ErrorBoundary;
